<div class="row">
    <div class="col-sm-12">
        <div class="card" style="background-color:#02275d; color: white; border-radius: 0px;">
            <p class="mb-2 mt-2 mx-auto" [innerHTML]="txtCopyright"></p>
        </div>
    </div>
</div>

